<template>
  <div class="form-elements">
        <div class="row" v-show="!download.load">
            <div class="form-group">
                <div class="col-md-6">
                    <input type="date" id='inicio'>
                </div>
                <div class="col-md-6">
                    <input type="date" id='fim'>
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-12">
                    <button @click="getAulasTeoricasPraticasHoje()" class="btn btn-primary btn-micro">Gerar Relatório</button>
                </div>
            </div>
        </div>
        <div v-show="download.load">
            <span>Pode demorar um pouco...</span>
            <div class="d-flex justify-content-center">
                <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                    <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as spinners from 'epic-spinners'
import urlApiV2 from '@/router/urlApiV2'
    
export default {
    name: 'PraticasTeoricasHoje',
    components: {
        ...spinners,
    },
    data() {
        return {
            download:{
                load: false
            },
        }
    },
    methods: {
        async getAulasTeoricasPraticasHoje()
        {
            this.download.load = true;
            let dataI = document.getElementById('inicio').value;
            let dataF = document.getElementById('fim').value;

            if(dataI === '' || dataF === '') {
                this.$toasted.show('Por favor, informe o período!', {
                    position: 'top-right',
                })
                this.download.load = false;
            } else {
                await this.$http.get(urlApiV2 + '/turmas/hoje/planilha/' + dataI + '/' + dataF ).then(this.downloadCSV)
                this.$http.get(urlApiV2 + `/aulas/praticas/hoje/planilha?dataInicial=${dataI}&dataFinal=${dataF}` ).then(this.downloadCSV)
            }
        },
        downloadCSV(response)
        {
            if(response.data.dados){
                var dlnk = document.getElementById('downloadCSV');
                dlnk.download="novoCFC.csv";
                dlnk.href = 'data:text/csv;charset=utf-8,' + response.data.dados;
                dlnk.click();
                this.download.load = false;
            }else{
                this.$toasted.show('Consulta não possui resultado', {
                    position: 'top-right',
                })
                this.download.load = false;
            }
        },
    },
}
</script>